import { inject } from '@angular/core';
import { menuItems } from '@softline/application';
import { Template } from '../../user/templates/template';
import { TemplateService } from '../services/template.service';

export function templates<T>(
  group: string,
  applyTemplateCallback: (template: Template<T>) => void,
  getTemplateValueCallback: () => T | null
): void {
  const service = inject(TemplateService);
  menuItems(() => [
    {
      title: 'Vorlage laden',
      name: 'load-template',
      type: 'execute',
      icon: 'fa-regular fa-folder-magnifying-glass',
      outlet: 'action',
      canExecute: true,
      execute: async () => {
        const template = await service.select<T>(group);
        if (!template) return;
        applyTemplateCallback(template);
      },
    },
    {
      title: 'Vorlage speichern',
      name: 'save-template',
      type: 'execute',
      icon: 'fa-regular fa-folder-medical',
      outlet: 'action',
      canExecute: true,
      execute: async () => {
        const template = getTemplateValueCallback();
        if (!template) return;
        await service.add<T>(group, template);
      },
    },
  ]);
}
